import { Component } from '@angular/core'
import { FormErrorsComponent } from '@spartacus/storefront'

@Component({
  selector: 'mb-form-errors',
  templateUrl: './mb-form-errors.component.html',
  styleUrls: ['./mb-form-errors.component.scss'],
})
export class MbFormErrorsComponent extends FormErrorsComponent {
}
